import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid, clientType) {
  const data = {
    username,
    password,
    code,
    uuid,
    clientType
  }
  return request({
    url: '/login',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 验证openId
// export function verifyAppWxOpenIdAPI(params) {
//   return request({
//     url: '/api/ucenter/wx/gzh/verifyOpenId',
//     method: 'get',
//     params,
//     timeout: 20000
//   })
// }

// 未登录微信账号绑定
export function gzhWxBindingLoginAPI(data) {
  return request({
    url: '/api/ucenter/wx/gzh/export/bindingAndLogin',
    method: 'POST',
    data,
    timeout: 20000
  })
}

// 公众号已登录微信账号绑定
export function gzhWxBindingAPI(data) {
  return request({
    url: '/api/ucenter/wx/gzh/binding',
    method: 'POST',
    data,
    timeout: 20000
  })
}

// 公众号账号解绑
export function gzhUnWxBindAPI() {
  return request({
    url: '/api/ucenter/wx/gzh/unbind',
    method: 'GET',
    timeout: 20000
  })
}

// 公众号未登录验证code
export function verifyGzhWxCodeLoginAPI(params) {
  return request({
    url: '/api/ucenter/wx/gzh/export/verifyAndLogin',
    method: 'get',
    params,
    timeout: 20000
  })
}

// 公众号已登录验证code
export function verifyGzhWxCodeAPI(params) {
  return request({
    url: '/api/ucenter/wx/gzh/verify',
    method: 'get',
    params,
    timeout: 20000
  })
}

// 公众号注册验证code
export function verifyGzhAuthWxCodeAPI(params) {
  return request({
    url: '/api/ucenter/wx/gzh/export/verify/unAuth',
    method: 'GET',
    params,
    timeout: 20000
  })
}

// 公众号未登录短信绑定并登录
export function gzhPhoneCodeAPI(data) {
  return request({
    url: '/api/ucenter/wx/gzh/export/sms/bindingAndLogin',
    method: 'POST',
    data,
    timeout: 20000
  })
}

// APP验证openId
export function verifyAppWxOpenIdAPI(params) {
  return request({
    url: '/api/ucenter/wx/app/export/verifyOpenId',
    method: 'get',
    params,
    timeout: 20000
  })
}

// app已登录微信账号绑定
export function appWxBindingAPI(data) {
  return request({
    url: '/api/ucenter/wx/app/binding',
    method: 'POST',
    data,
    timeout: 20000
  })
}

// app微信账号解绑
export function appUnWxBindAPI() {
  return request({
    url: '/api/ucenter/wx/app/unbind',
    method: 'GET',
    timeout: 20000
  })
}

// app未登录微信账号绑定
export function appWxBindingLoginAPI(data) {
  return request({
    url: '/api/ucenter/wx/app/export/bindingAndLogin',
    method: 'POST',
    data,
    timeout: 20000
  })
}

// app未登录短信绑定并登录
export function appPhoneCodeAPI(data) {
  return request({
    url: '/api/ucenter/wx/app/export/sms/bindingAndLogin',
    method: 'POST',
    data,
    timeout: 20000
  })
}